import React from "react";
import TrackVisibility from "react-on-screen";

const AboutMe = () => {
  return (
    <section className="project">
      <TrackVisibility>
        {({ isVisible }) => (
          <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
            <h2>About Me</h2>
            <p>
              Hi, I’m Kamrul Hasan. I'm a skilled JS & React developer and have
              an active interest in web development and web technologies.
              Although I’m currently studying in Universität Rostock, Germany in
              Electrical Engineering , my perpetual love for programming and the
              web push me to do the challenges in this field. I just love to
              solve problems and want to meet new challenges and learn new
              technologies.
            </p>
          </div>
        )}
      </TrackVisibility>
    </section>
  );
};

export default AboutMe;
